import { STATUS_COLORS, PRIORITY_COLORS } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className }) {
  if (!status) return null;
  const c = STATUS_COLORS[status] || "bg-beige text-burgundy border-gold/30";
  return (
    <span
      data-testid={`status-badge-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
      className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border whitespace-nowrap", c, className)}
    >
      {status}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  if (!priority) return null;
  const c = PRIORITY_COLORS[priority] || "bg-gray-100 text-gray-600";
  return <span className={cn("inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wide", c)}>{priority}</span>;
}
